import React from "react";
import { useState } from "react";


const Accordion = ({titulo, opciones}) => {

    const [accordionOpen, setAccordionOpen] = useState(false)

    return (
        <div>
            <button
                onClick={() => setAccordionOpen(!accordionOpen)}
                className="flex justify-between w-full"
            >
                <span>{titulo}</span>
                {accordionOpen ? <span>-</span> : <span>+</span>}
            </button>
            <div
                className={`grid overflow-hidden transition-all duration-300 ease-in-out text-orange-500 text-[10pt]
                ${accordionOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0' } `}
                >
            <div className="overflow-hidden">{opciones}</div>
            </div>
        </div>
    )
}

export default Accordion;